export const BookingStatus = {
  PREBOOKED: 'Prebooked',
  PREBOOK_CANCELLED: 'PrebookCancelled',
  CONFIRMED: 'Confirmed',
  UPDATED: 'Updated', // Only used on frontend. Send Confirmed to backend
  CANCELLED: 'Cancelled'
};
Object.freeze(BookingStatus);
